import { User } from '@app/core/models/user.model';

export const USER_INFO: User = {
  name: 'Mover',
  email: 'mover@wearemo.com',
};
